export const FAVICON_LINKS_SELECTOR = "link[rel~='icon']";

export enum LinkAttributes {
  Sizes = 'sizes',
  Href = 'href',
}
